
const DoseSpotErrorModalStyle = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: "center"
    },
    modalWrapper: {
        outline: "none",
        minHeight: 222,
        width: 566,
        overflow: "hidden",
        position: "relative",
        border: "1px solid #979797",
        borderRadius: 4,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
    },
    modalHeader: {
        maxHeight: 24,
        display: "flex",
        flex: 1,
        backgroundColor: "#d2dcdd",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 16,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        paddingLeft: 13,
        alignItems: "center"
    },
    modalBody: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "space-between"
    },
    modalActionWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginBottom: 15,
        marginRight: 15
    },
    contentWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        marginTop: 27,
        marginBottom: 28,
        textAlign: "center",
        minHeight: 51,
        paddingLeft: 41,
        paddingRight: 41,
        whiteSpace: "pre-line"
    },
    spanText: {
        marginTop: 20
    },
    buttonStyle: {
        boxShadow: 'none',
        width: 108,
        height: 30,
        marginBottom: 25,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
})

export default DoseSpotErrorModalStyle;